import React from "react";
import "./Requirements.css";
import { useTranslation } from "react-i18next";
const LoomisRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      {t("carriers.custom.requirements.loomis")}
    </div>
  );
};

export default LoomisRequirements;
